import React, {useState} from 'react';
export default function SelectBoxDbName(props) {
    const [active, setActive] = useState(false);
    const [selected, setSelected] = useState('Mongo DB');
    const open = () => {
        if(!props.status)
            setActive(!active)
    }
    const select = (select,uri) => {
        setSelected(select)
        props.setDbUri(uri)
        setActive(false)
    }
    return (
        <div onClick={open} className={`select-box d-flex justify-content-between align-items-center ${props.status && 'select-box-disable'} ${active && 'select-box-active'} ${props.className}`}>
            <p>{selected}</p>
            <svg xmlns="http://www.w3.org/2000/svg" width="12.732" height="7.426" viewBox="0 0 12.732 7.426">
                <g id="ArrowDown" transform="translate(-407.939 -377.939)">
                    <path id="Line_19" d="M0 5.305L5.305 0" style={{fill:'none',stroke:'#111e5d',strokeLinecap:'round',strokeWidth:1.5}} className="cls-1" transform="rotate(-90 396.653 -12.348)"/>
                    <path id="Line_20" d="M0 0L5.305 5.305" style={{fill:'none',stroke:'#111e5d',strokeLinecap:'round',strokeWidth:1.5}} className="cls-1" transform="rotate(-90 399.305 -15)"/>
                </g>
            </svg>
            {active &&
            <div className="sub-select">
                {props.database.map((value,key)=>(
                    <p key={key} onClick={() => select(value[1],value[0])}>{value[1]}</p>
                ))}
            </div>}
        </div>
    );
}
